<template>
  <Icon v-if="icon" :icon="icon" size="m" class="margin-bottom-xs" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Icon from '@atomic-ui/icon/Icon';
import {
  csgSize,
  csgComfort,
  csgMattressType,
  csgThickness,
  csgSleepPosition,
  csgAward,
  csgConsciousBeauty,
  csgSustainable,
  csgIngredientConcern,
  csgFormulation,
  csgSkinConcern,
  csgSkinType,
  csgCoverage,
  csgFinish,
  csgIntensity,
  csgFragranceFamily,
  csgNotes,
  csgPeople,
  csgCertification,
  csgProfile,
  csgList,
  csgCoolingFeature,
  csgSupport,
  csgTopLayer,
} from '@csgSvgIcons/icons';

const props = defineProps({
  attributeName: {
    type: String,
    default: '',
  },
  isMattress: {
    type: Boolean,
    default: false,
  },
});

/**
 * EXACT_MATCH_MAP stores attribute name to icon pairs where the mapping is unambiguous across brands and divisions.
 * Attribute names are expected in NAME_TEXT format (uppercase, underscores).
 */
const EXACT_MATCH_MAP = {
  // Mattress Attributes
  BED_SIZE_T: csgSize,
  BED_SIZE_SITE: csgSize,
  BED_SIZE: csgSize,
  MATTRESS_COMFORT: csgComfort,
  MATTRESS_TYPE: csgMattressType,
  MATTRESS_CONSTRUCTION: csgMattressType,
  MATTRESS_HEIGHT: csgThickness,
  THICKNESS: csgThickness,
  SLEEP_POSITION: csgSleepPosition,
  SLEEP_POSITION_TYPE: csgSleepPosition,
  COOLING_FEATURE: csgCoolingFeature,
  MATTRESS_SUPPORT: csgSupport,
  TOP_LAYER: csgTopLayer,

  // Beauty / Fragrance Attributes
  AWARD_WINNER: csgAward,
  CONSCIOUS_BEAUTY: csgConsciousBeauty,
  'SUSTAINABLE_&_MINDFUL': csgSustainable,
  DIVERSE_OWNED_BRANDS: csgPeople,
  INGREDIENT_CONCERN: csgIngredientConcern,
  INGREDIENT_PREFERENCE: csgIngredientConcern,
  INGREDIENTS: csgIngredientConcern,
  FORMULATION_TYPE: csgFormulation,
  MAKEUP_FORMULATION: csgFormulation,
  SKIN_CONCERN: csgSkinConcern,
  CONCERN: csgSkinConcern,
  SKIN_TYPE: csgSkinType,
  COVERAGE: csgCoverage,
  FOUNDATION_COVERAGE: csgCoverage,
  FINISH: csgFinish,
  FOUNDATION_FINISH: csgFinish,
  INTENSITY: csgIntensity,
  FRAGRANCE_CONCENTRATION: csgIntensity,
  SCENT: csgFragranceFamily,
  FRAGRANCE_NOTES: csgNotes,
  FRAGRANCE_SCENTS: csgNotes,
  GENDER: csgProfile,
  SUSTAINABLE_VERIFICATION: csgSustainable,
};

/**
 * Type name specific mappings for attributes that share the same name but require different icons.
 */
const MATTRESS_SPECIFIC_MAP = {
  SUSTAINABLE_VERIFICATION: csgCertification,
};

const icon = computed(() => {
  if (!props.attributeName) return null;

  const name = props.attributeName.toUpperCase();
  const fullMapping = {
    ...EXACT_MATCH_MAP,
    ...(props.isMattress && MATTRESS_SPECIFIC_MAP),
  };

  return fullMapping[name] || csgList;
});
</script>
